import { components } from '../../../types/be-schema';
import { getUserAuthHeader } from '../user/client-fetch';

export const putEditableDealerInfo = async (
  dealerInfo: components['schemas']['PutEditableDealerInfo']
) => {
  return fetch('/api/editable_dealer_info', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: (await getUserAuthHeader()) ?? '',
    },
    body: JSON.stringify(dealerInfo),
  });
};
